import * as C from "../constants";
import { createReducer } from "../utils/misc";

const initialState = {
    orders: {
        isLoading: false,
        isLoaded: false,
        data: [],
        count: null,
        page: null,
        pages: null,
        rowsPerPage: 25,
        water: null,
        cash_sum: null,
        cashless_sum: null,
        key_sum: null,
        bonus_sum: null,
        purchase_sum: null,
    },
    encashments: {
        isLoading: false,
        isLoaded: false,
        data: [],
        count: null,
        cash: null,
    },
    keysTransactions: {
        isLoading: false,
        isLoaded: false,
        data: [],
        count: null,
    },
    machines: {
        isLoading: false,
        isLoaded: false,
        data: [],
        count: null
    },
    statusText: "",
};

export default createReducer(initialState,{
    [C.GET_ORDERS_REQUEST]: (state) => ({
        ...state,
        orders: {
            ...state.orders,
            isLoading: true,
        }
    }),
    [C.GET_ORDERS_FAILURE]: (state) => ({
        ...state,
        orders: {
            ...state.orders,
            isLoading: false,
            isLoaded: false,
        },
        statusText: "Ошибка загрузки списка продаж",
    }),
    [C.GET_ORDERS_SUCCESS]: (state, payload) => ({
        ...state,
        orders: {
            ...state.orders,
            isLoading: false,
            isLoaded: true,
            data: payload.orders,
            count: payload.count,
            page: payload.page,
            pages: payload.pages,
            water: payload.water,
            cash_sum: payload.cash_sum,
            cashless_sum: payload.cashless_sum,
            key_sum: payload.key_sum,
            bonus_sum: payload.bonus_sum,
            purchase_sum: payload.purchase_sum,
        }
    }),
    [C.GET_ENCASHMENTS_REQUEST]: (state) => ({
        ...state,
        encashments: {
            ...state.encashments,
            isLoading: true,
        }
    }),
    [C.GET_ENCASHMENTS_FAILURE]: (state) => ({
        ...state,
        encashments: {
            ...state.encashments,
            isLoading: false,
            isLoaded: false,
        },
        statusText: "Ошибка загрузки списка инкассации",
    }),
    [C.GET_ENCASHMENTS_SUCCESS]: (state, payload) => ({
        ...state,
        encashments: {
            ...state.encashments,
            isLoaded: true,
            isLoading: false,
            data: payload.encashments,
            count: payload.count,
            page: payload.page,
            pages: payload.pages,
            cash: payload.cash,
        }
    }),
    [C.GET_ORDERS_MACHINES_REQUEST]: (state) => ({
        ...state,
        machines: {
            ...state.machines,
            isLoading: true,
        }
    }),
    [C.GET_ORDERS_MACHINES_FAILURE]: (state) => ({
        ...state,
        machines: {
            ...state.machines,
            isLoading: false,
            isLoaded: false,
        },
        statusText: "Ошибка загрузки списка id автоматов."
    }),
    [C.GET_ORDERS_MACHINES_SUCCESS]: (state, payload) => ({
        ...state,
        machines: {
            ...state.machines,
            isLoading: false,
            isLoaded: true,
            data: payload,
            count: payload.length,
        }
    }),
    [C.GET_KEYS_TRANSACTIONS_REQUEST]: (state) => ({
        ...state,
        keysTransactions: {
            ...state.keysTransactions,
            isLoading: true
        }
    }),
    [C.GET_KEYS_TRANSACTIONS_FAILURE]: (state) => ({
        ...state,
        keysTransactions: {
            ...state.keysTransactions,
            isLoading: false,
            isLoaded: false,
        }
    }),
    [C.GET_KEYS_TRANSACTIONS_SUCCESS]: (state, payload) => ({
        ...state,
        keysTransactions: {
            ...state.keysTransactions,
            isLoading: false,
            isLoaded: true,
            data: payload.keys_transactions,
            count: payload.count,
            page: payload.page,
            pages: payload.pages,
        }
    })
})


// WEBPACK FOOTER //
// ./src/reducers/orders.js